var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slick-carousel',{key:_vm.carouselKey,ref:"slick",staticClass:"base-slider",attrs:{"options":_vm.slickOptions},on:{"afterChange":_vm.handleAfterChange}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }